import * as entity from '@common/domain/entities/RequisitionPartialWorkflow'
import { IApiServiceCommand } from '../../../services/api/api.service';
import * as app from '@framework/app';
import { IDataEndPoint } from '../../../framework/interfaces/IEntity';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
export class RequisitionPartialWorkflowEndPoints extends entity.RequisitionPartialWorkflowEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow/perRequisition/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionPartialWorkflow/perRequisitionCount/" + serviceCommand.context.entityId }, method: "POST"
  }
}

export class RequisitionPartialWorkflowFormFields extends entity.RequisitionPartialWorkflowFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
  }
}

export class RequisitionPartialWorkflowForm extends entity.RequisitionPartialWorkflowForm {
  protected requisitionPartialWorkflowFormEndPoints: RequisitionPartialWorkflowEndPoints = new RequisitionPartialWorkflowEndPoints();
  protected requisitionPartialWorkflowFormFields: RequisitionPartialWorkflowFormFields = new RequisitionPartialWorkflowFormFields();
}

export class RequisitionPartialWorkflowListColumns extends entity.RequisitionPartialWorkflowListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.workflowId.visible = false;
      this.splice(this.indexOf(this.requisitionPartialId), 1)
      this.splice(this.indexOf(this.userId), 1)
      this.splice(this.indexOf(this.comments), 1)
      this.unshift(FormBuilderControlListHelper.getListColumn("datestamp", "Date", null, null, "date_formatted"));
      this.push(FormBuilderControlListHelper.getListColumn("workflow.name", "Workflow", null, null, "workflow_name"));
      this.push(FormBuilderControlListHelper.getListColumn("userId", "User", null, null, "user"));

      this.push(this.comments)
    } catch  { }
  }
}

export class RequisitionPartialWorkflowList extends entity.RequisitionPartialWorkflowList {
  protected requisitionPartialWorkflowListEndPoints: RequisitionPartialWorkflowEndPoints = new RequisitionPartialWorkflowEndPoints();
  protected requisitionPartialWorkflowListColumns: RequisitionPartialWorkflowListColumns = new RequisitionPartialWorkflowListColumns();
}

